import { Button, Col, Divider, Form, Input, Row, Select, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IState } from '../../../../redux/store';
import tableData from '../../filepicker/tableData';
import httpRequest from '../../../../utils/HttpRequest';
import { urls } from '../../../../config/url';
import Item from 'antd/lib/list/Item';
import { classNames } from '../../../../utils/classNames';
import { updateParam } from '../../../../redux/progress/param/paramAction'
import { IModuleParams } from '../../../../redux/progress/param/paramReducer';
import { log } from '@antv/g2plot/lib/utils';
import { cursorTo } from 'readline';


function ModelTable(props: {
    line: string,
    point: string,
    userName: string,
    className?: string,
    updateParam: (param: IModuleParams) => void,
    cancalData: (param: IModuleParams) => void,
    status: boolean,
    tableBtn: (param: boolean) => void,
    empty: boolean,
    activeName: string,
    lineName: string
}) {

    // 表格数据
    const [tableArr, setTable] = useState<any>([{ line: '', point: '', devno: '' }, { line: '', point: '', devno: '' }, { line: '', point: '', devno: '' }, { line: '', point: '', devno: '' }, { line: '', point: '', devno: '' }])
    // 设备号
    const [deviceNum, setDeviceNum] = useState<any>([])

    const [allData, setAllData] = useState<any>([])

    const [btnClick, setBtnClick] = useState<boolean>(false)
    useEffect(() => {
        setBtnClick(props.status)
    }, [props.status])

    useEffect(() => {
        if (props.empty) {
            let arr: { devno: any; line: string; point: string; }[] = []
            tableArr.map((item: { devno: any; }, i: any) => {
                arr.push({ devno: item.devno, line: '', point: '' })
            })
            setTable([...arr])
        }
    }, [props.empty])
    useEffect(() => {
        if (props.line === '' && props.point === '') {
            return
        }
        let lineArr = props.line.split(',')
        let pointArr = props.point.split(',')
        let arr: { line: number; point: number; devno: number | string }[] = []
        for (var r = 0; r < (+lineArr[1] - +lineArr[0] + 1); r++) {

            for (var c = 0; c < (+pointArr[1] - +pointArr[0] + 1); c++) {
                let x = (+lineArr[0]) + (r * +(lineArr[2]))
                let y = (+pointArr[0]) + (c * +(pointArr[2]))
                arr.push({
                    line: x, point: y,
                    devno: ''
                })
            }

        }
        let cancal: { line: number; point: number; devno: number | string }[] = []
        if (deviceNum.length != 0) {
            if (arr.length > deviceNum.length) {
                arr.map((item, i) => {
                    cancal.push({ line: item.line, point: item.point, devno: deviceNum[i] })
                })

            } else {
                deviceNum.map((item: string, i: number) => {
                    cancal.push({ line: arr[i].line, point: arr[i].point, devno: item })

                })
            }
        } else {
            cancal = arr
        }


        setTable([...cancal])

    }, [props.line, props.point])

    const deviceBtn = () => {
        httpRequest(urls.fixtimedevice, Object.assign({}, {}, {
            "USER_NAME": props.userName,
            "PROJECTNAME": props.activeName,
            "proj_name": props.lineName,
        }))
            .then(res => {
                let arr = res.data.data // 设备号
                let data: { line: string; point: string; devno: any; }[] = []

                setDeviceNum(res.data.data)
              
                
                if (tableArr.length === 0) {
                    arr && arr.map((item: any, i: any) => {
                        data.push({ line: '', point: '', devno: item })
                    })
                    setTable(data)
                } else {

                    if (tableArr.length > arr.length) {
                        message.error('设备号比线号点号少，请进行删除')
                        tableArr && tableArr.map((item: any, i: any) => {
                            data.push({ line: item.line, point: tableArr[i].point, devno: arr[i] === undefined ? '' : arr[i] })
                        })
                        setTable(data)
                        return
                    } else if (tableArr.length < arr.length) {
                        let len = arr.length - tableArr.length
                        message.error('设备号多' + len + '个，线号点号补充为-999')
                        arr && arr.map((item: any, i: any) => {
                            data.push({ line: tableArr[i] === undefined ? '-999' : tableArr[i].line, point: tableArr[i] === undefined ? '-999' : tableArr[i].point, devno: item })
                        })
                        setTable(data)
                        return
                    } else {
                        tableArr && tableArr.map((key: any, val: any) => {
                            data.push({ line: key.line, point: key.point, devno: arr[val] })
                        })
                        
                        setTable(data)
                    }
                }
            })

            .catch(console.error);

    }


    useEffect(() => {

        if (props.cancalData) {
            props.cancalData(allData)
        }

    }, [allData])
    useEffect(() => {
        if (props.tableBtn) {
            props.tableBtn(btnClick)
        }
    }, [btnClick])
    return <>
        <div >
            <table >
                <tr>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>序号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>设备号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>线号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>点号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>操作</td>

                </tr>
                {
                    tableArr && tableArr.map((item: { line: any; point: any; }, i: number) => {

                        return (
                            <tr >
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>{i + 1}</td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} disabled={props.status || btnClick} style={{ width: 100, }}
                                        value={deviceNum[i]}
                                        onChange={(e) => {
                                            let arr = deviceNum
                                            let table1 = tableArr
                                            arr[i] = e.target.value
                                            table1[i].devno = e.target.value
                                            setDeviceNum([...arr])
                                            setTable([...table1])
                                        }}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={props.status || btnClick} value={item.line} onChange={(e) => {
                                        let arr = tableArr
                                        arr[i].line = Number(e.target.value)
                                        setTable([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={props.status || btnClick} value={item.point} onChange={(e) => {
                                        let arr = tableArr
                                        arr[i].point = Number(e.target.value)
                                        setTable([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <div style={{
                                        display: 'inline-block',
                                        width: 25,
                                        height: 25,
                                        borderRadius: '50%',
                                        border: '1px solid #ccc',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        verticalAlign: 'middle',
                                    }} onClick={() => {
                                        if (props.status || btnClick) {
                                            message.warn('请先点击重置再对数据进行修改')
                                            return
                                        }
                                        let arr = tableArr
                                        let device = deviceNum
                                        arr.splice(i + 1, 0, { line: '', point: '', devno: '' });
                                        device.splice(i + 1, 0, '');
                                        setDeviceNum([...device])
                                        setTable([...arr])


                                    }}>
                                        +
                                    </div>
                                    <div style={{
                                        display: 'inline-block',
                                        width: 25,
                                        height: 25,
                                        borderRadius: '50%',
                                        border: '1px solid #ccc',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        verticalAlign: 'middle',
                                        marginLeft: 20
                                    }} onClick={() => {
                                        if (props.status || btnClick) {
                                            message.warn('请先点击重置再对数据进行修改')
                                            return
                                        }
                                        let arr = tableArr
                                        let device = deviceNum
                                        if (arr.length === 1) {
                                            message.warning('数据至少有一条')
                                            return 
                                        }
                                        arr.splice(i, 1)
                                        device.splice(i, 1)
                                        setTable([...arr])
                                        setDeviceNum([...device])

                                    }} >
                                        -
                                    </div>

                                </td>
                            </tr>
                        )
                    })
                }
                <tr>
                    <td colSpan={5} style={{ border: '1px solid #ccc', height: 26, padding: 10 }}>

                        <Button style={{ float: 'right' }} type='primary' size='large' onClick={() => {

                            const checkarr = []
                            const cancalTable = []
                            const devno = []


                            for (let index = 0; index < tableArr.length; index++) {
                                const element = tableArr[index];
                                if (element.devno != '' && element.devno != undefined) {
                                    cancalTable.push(element)
                                    devno.push(element.devno)
                                    checkarr.push(element.line * 1000 + element.point)
                                }

                            }
                            setTable([...cancalTable])
                            setAllData([...cancalTable])
                            for (var i = 0; i < checkarr.length; i++) {
                                if (checkarr.indexOf(checkarr[i]) != i) {
                                    message.error("数据有重复元素：线号" + cancalTable[i].line + ',点号' + cancalTable[i].point)
                                    return
                                }
                            }
                            for (var i = 0; i < devno.length; i++) {
                                if (devno.indexOf(devno[i]) != i) {
                                    message.error("设备号有重复：" + devno[i])
                                    return
                                }
                            }
                            setBtnClick(true)
                        }} disabled={btnClick}>确认</Button>
                        <Button size='large' style={{ float: 'right', marginRight: 10 }} type='primary' disabled={props.status} onClick={() => {
                            setBtnClick(false)
                        }}>重置</Button>
                        <Button style={{ float: 'right', marginRight: 10 }} type='primary' onClick={deviceBtn} disabled={props.status} size='large' >设备号</Button>
                    </td>
                </tr>
            </table>

        </div>

    </>
}

const mapStateToProps = (state: IState) => {
    const userName = state.user.userName;
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
        userName,
        activeName: state.project.activeName,
        lineName: state.progress.line.activeName
    };
};

export default connect(
    mapStateToProps,
    { updateParam }
)(ModelTable);
